import { render, staticRenderFns } from "./CreateDocument.vue?vue&type=template&id=a3b18bba"
import script from "./CreateDocument.vue?vue&type=script&lang=ts"
export * from "./CreateDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports